import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import Select from '@/components/form/fields/select'
import Terms from '@/components/form/fields/terms'
import TextField from '@/components/form/fields/text'
import TextElement from '@/components/text-element/text-element'
import { formMessages } from '@/constants/form-messages'
import { type FormWebsite } from '@/internal/types/form'

const StepContactInfo: React.FC = () => {
  const data: Queries.StepContactInfoQueryQuery = useStaticQuery(graphql`
    query StepContactInfoQuery {
      allDatoCmsGctCountry(filter: {}, sort: { externalName: ASC }) {
        nodes {
          externalName
          id
        }
      }
      allDatoCmsGctIndustry(filter: {}, sort: { externalName: ASC }) {
        nodes {
          externalName
          id
        }
      }
      allDatoCmsGctRole(filter: {}, sort: { externalName: ASC }) {
        nodes {
          externalName
          id
        }
      }
      companies: allAirtable(
        filter: { table: { eq: "Company" } }
        sort: { data: { Name: ASC } }
      ) {
        nodes {
          data {
            Name
          }
        }
      }
    }
  `)

  const countries = data.allDatoCmsGctCountry.nodes.map((node) => {
    return {
      value: node.externalName,
      label: node.externalName
    }
  })
  const industries = data.allDatoCmsGctIndustry.nodes.map((node) => {
    return {
      value: node.externalName,
      label: node.externalName
    }
  })
  const roles = data.allDatoCmsGctRole.nodes.map((node) => {
    return { value: node.externalName, label: node.externalName }
  })
  const companies = data.companies.nodes.map((node) => {
    return { value: node?.data?.Name, label: node?.data?.Name }
  })
  const { getValues } = useFormContext()
  const values = getValues() as FormWebsite
  const labels = formMessages[values.form]
  return (
    <>
      <TextElement type="h2" text={labels.stepContactInfoTitle} />
      <TextElement
        type="p"
        className="text-center"
        text={labels.stepContactInfoDescription}
      />
      {/* <div className={styles.leftLabel}>
        <TextField id="name" label="Name" align="left" required />
      </div> */}
      <TextField id="name" label="Name" align="leftLabel" required />
      <Select
        id="role"
        label="Role"
        options={roles}
        required
        create={false}
        align="leftLabel"
      />
      <Select
        id="company"
        label="Company"
        options={companies}
        required
        create
        align="leftLabel"
      />
      <Select
        id="industry"
        label="Industry"
        options={industries}
        required
        create={false}
        align="leftLabel"
      />
      <Select
        id="country"
        label="Country"
        options={countries}
        required
        create={false}
        align="leftLabel"
      />

      <div className="customCheckboxes">
        <Terms />
      </div>
    </>
  )
}

export default StepContactInfo
